import * as moment from 'moment';
import { TemplateService } from '../../services/template.service';
import { CALENDAR_LOCALE } from '../../services/constant';
import { ApiService } from '../../services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { HttpParams } from '@angular/common/http';
var HistoryLogComponent = (function () {
    function HistoryLogComponent(modalService, apiService, template, translate) {
        this.modalService = modalService;
        this.apiService = apiService;
        this.template = template;
        this.translate = translate;
        this.loading = false;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.errors = [];
        this.selectedCustomercode = null;
        this.checkdate = null;
        this.defaultLabel = null;
        this.sortBy = null;
        this.sortMode = null;
        this.no_data = true;
        this.errorMsg = '';
        this.allDeliverycode = true;
        this.allDocType = true;
        this.selectedValues = [];
        this.usernames = [];
        this.roles = [];
        this.searchAction = [];
        this.tableCol = [];
        this.loading_excel_report = false;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
    }
    HistoryLogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.clearSearch();
        this.searchButtonClicked();
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.clearSearch();
            _this.searchButtonClicked();
        });
    };
    HistoryLogComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    HistoryLogComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = '';
        }
        else {
            this.sortMode = '-';
        }
    };
    HistoryLogComponent.prototype.clearSearch = function () {
        this.searchUsername = '';
        this.searchRole = '';
        this.searchAction = [];
        this.loadSearch();
    };
    HistoryLogComponent.prototype.loadSearch = function () {
        var _this = this;
        this.loadUsers();
        this.loadRoles();
        this.loadActions();
        this.loadDates();
        this.tableCol = [];
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            _this.tableCol.push({ field: 'created_at', header: _this.translate.instant('HISTORY.DATE') }, { field: 'role', header: _this.translate.instant('HISTORY.ROLE') }, { field: 'actor', header: _this.translate.instant('HISTORY.USERNAME') }, { field: 'action', header: _this.translate.instant('HISTORY.ACTION') }, { field: 'address', header: _this.translate.instant('HISTORY.ADDRESS') });
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
        });
        this.currentPage = 1;
    };
    HistoryLogComponent.prototype.loadUsers = function () {
        var _this = this;
        this.usernames = [];
        this.usernames = [{
                'label': this.translate.instant('COMMON.ALL'),
                'value': ''
            }];
        this.loading = true;
        this.apiService.getUsers().subscribe(function (users) {
            _.forEach(users, function (user) {
                _this.usernames.push({
                    'label': user.username,
                    'value': user.id
                });
            });
            _this.loading = false;
            _this.usernames = _.uniqBy(_this.usernames, 'label');
        }, function (error) {
            _this.loading = false;
            console.log('error', error);
        });
    };
    HistoryLogComponent.prototype.loadRoles = function () {
        var _this = this;
        this.roles = [];
        this.roles = [{
                'label': this.translate.instant('COMMON.ALL'),
                'value': ''
            }];
        this.loading = true;
        this.apiService.getRoles().subscribe(function (roles) {
            _.forEach(roles, function (role) {
                _this.roles.push({
                    'label': role.name,
                    'value': role.id
                });
            });
            _this.loading = false;
            _this.roles = _.uniqBy(_this.roles, 'label');
        }, function (error) {
            _this.loading = false;
            console.log('error', error);
        });
    };
    HistoryLogComponent.prototype.loadActions = function () {
        var _this = this;
        this.actions = [];
        this.loading = true;
        this.apiService.getActions().subscribe(function (actions) {
            _.forEach(actions.results, function (action) {
                _this.actions.push({
                    'label': _this.translate.instant('HISTORY.ACTION-ENUM.' + action.name),
                    'value': action.name
                });
            });
            _this.loading = false;
            _this.actions = _.uniqBy(_this.actions, 'label');
        }, function (error) {
            _this.loading = false;
            console.log('error', error);
        });
    };
    HistoryLogComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    HistoryLogComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    Object.defineProperty(HistoryLogComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryLogComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    HistoryLogComponent.prototype.loadDates = function () {
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
    };
    HistoryLogComponent.prototype.sentDate = function () {
        this.checkdate = 1;
    };
    HistoryLogComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.searchData();
    };
    HistoryLogComponent.prototype.searchData = function (params) {
        var _this = this;
        this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            actor_id: this.searchUsername,
            role_id: this.searchRole,
            action: this.searchAction.join(','),
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD')
        };
        var sniffTargetArr = [];
        if (this.searchUsername) {
            sniffTargetArr.push('HISTORY.USERNAME');
        }
        if (this.searchRole) {
            sniffTargetArr.push('HISTORY.ROLE');
        }
        if (this.searchAction.length !== 0) {
            sniffTargetArr.push('HISTORY.ACTION');
        }
        if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
            sniffTargetArr.push('HISTORY.DATE');
        }
        if (this.sortBy) {
            if (this.sortBy === 'action') {
                data['ordering'] = this.sortMode + this.sortBy + ',' + this.sortMode + 'target';
            }
            else {
                data['ordering'] = this.sortMode + this.sortBy;
            }
        }
        if (this.currentPage === 1) {
            params = null;
        }
        this.apiService.getSniffs(data).subscribe(function (result) {
            _this.loading = false;
            _this.tempTableData = result.results;
            _this.tableData = _this.tempTableData.map(function (resultData) {
                resultData.action_display = 'HISTORY.ACTION-ENUM.' + resultData.action_display;
                resultData.address_display = 'HISTORY.ADDRESS-ENUM.' + resultData.address_display;
                var searchTarget = [];
                if (resultData.action === 'SEARCH' && resultData.target !== '') {
                    resultData.target.split(', ').forEach(function (element) {
                        var thislm = _this.translate.instant(element);
                        searchTarget.push(thislm);
                    });
                    resultData.searchtarget = searchTarget.join(', ');
                }
                else {
                    resultData.searchtarget = '';
                }
                return resultData;
            });
            _this.no_data = _.isEmpty(_this.tempTableData);
            if (result) {
                _this.totalItems = result.count;
            }
            return _this.tempTableData;
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
        if (params == null) {
            var sniffTarget = sniffTargetArr.join(', ');
            this.sniff('SEARCH', sniffTarget);
        }
    };
    HistoryLogComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
            errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY')
                + ' ' + errorMsgList.join(', ')
                + ' ' + this.translate.instant('COMMON.CORRECT');
            return;
        }
    };
    HistoryLogComponent.prototype.clearData = function () {
        this.clearSearch();
        this.tableData = undefined;
        this.no_data = true;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCustomercode = null;
        this.selectedDeliverycode = null;
        this.selectedRdDocumentType = null;
        this.deliverycode = null;
        this.documentType = null;
        this.notApprove = false;
        this.allDocType = true;
        this.allDeliverycode = true;
        this.sortBy = null;
        this.sortMode = null;
        this.selectedValues = [];
        this.searchButtonClicked();
    };
    HistoryLogComponent.prototype.pageChanged = function () {
        var params = new HttpParams();
        params = params.append('page', this.currentPage.toString());
        this.searchData(params);
    };
    HistoryLogComponent.prototype.DownloadReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            actor_id: this.searchUsername,
            role_id: this.searchRole,
            action: this.searchAction,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD')
        };
        this.apiService.getActionsLogExcelReport(params).subscribe(function (obj) {
            var filename = 'actions_log_report' + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            _this.loading_excel_report = false;
            _this.sniff('DOWNLOAD_XLS', filename);
        }, function (error) {
            _this.loading_excel_report = false;
        });
    };
    HistoryLogComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'ACTIONS_LOG',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    HistoryLogComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return HistoryLogComponent;
}());
export { HistoryLogComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.component.ts.pre-build-optimizer.js